import axios from 'axios';
import { Camera, X } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
export const MAX_FAULT_PHOTOS = 3;

export const FaultPhotoPicker = ({ files = [], onChange, testId }) => (
  <div className="flex flex-wrap items-center gap-2">
    {files.map((f, i) => (
      <span key={`${f.name}-${i}`} className="relative">
        <img src={URL.createObjectURL(f)} alt="" className="h-12 w-12 object-cover rounded border" />
        <button type="button" onClick={() => onChange(files.filter((_, j) => j !== i))} className="absolute -top-1 -right-1 bg-rose-600 text-white rounded-full p-0.5" aria-label="Remove photo">
          <X className="h-3 w-3" />
        </button>
      </span>
    ))}
    {files.length < MAX_FAULT_PHOTOS && (
      <label className="inline-flex items-center gap-1 text-xs border rounded px-2 py-1.5 cursor-pointer hover:bg-slate-50 text-slate-700" data-testid={testId}>
        <Camera className="h-4 w-4" /> Add photo ({files.length}/{MAX_FAULT_PHOTOS})
        <input type="file" accept="image/*" capture="environment" multiple className="hidden"
          onChange={(e) => { onChange([...files, ...Array.from(e.target.files || [])].slice(0, MAX_FAULT_PHOTOS)); e.target.value = ''; }} />
      </label>
    )}
  </div>
);

/** Upload each fault's photos once the server has returned fault ids (same order as submitted faults). */
export const uploadFaultPhotos = async (faultIds, faults, headers) => {
  let ok = 0; let failed = 0;
  for (let i = 0; i < faultIds.length && i < faults.length; i += 1) {
    for (const file of faults[i].photos || []) {
      const form = new FormData();
      form.append('file', file);
      try { await axios.post(`${API_URL}/api/fleet/faults/${faultIds[i]}/photos`, form, { headers }); ok += 1; } catch { failed += 1; }
    }
  }
  return { ok, failed };
};
